import {createAction} from "@reduxjs/toolkit";
import {actionTypeOf} from "./util";

const namespace = "financialInsitution";

export const unsetFinancialInstitution = createAction(
  actionTypeOf(namespace, "unsetFinancialInstitution")
);
